import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Root } from './composition/root';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root 가 없다');

createRoot(container).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
